export const Context = {
    "unit": "Easy Systems",
    "environment": "esprod",
    "cleanEnv": "prod",
    "baseUrl": "https://gateway.easysystems-cloud.com",
    "appUrl": "https://app.gateway.easysystems-cloud.com/",
    "ssoUrl": "",
    "apikey": "",
    "region": "eu-west-1",
    "buckedPrefix": "apigateway"
}